import React, { Fragment } from "react";
import { Grid } from "semantic-ui-react";
import { Link } from "../../../shims/useNavigate";

import { Filter, KeyValuePair } from "../../../types/types";

import EpcRatingTile from "../../UI/EpcRatingTile/EpcRatingTile";
import { EpcGrade, epcGrades } from "./EpcData";
import { compressToBase64 } from "lz-string";
import { compressDataTableState } from "../../../hooks/useQueryFromState";

interface EpcDataBreakdownProps {
	data: KeyValuePair;
}

const rangesByGrade: Record<EpcGrade, string> = {
	A: "(92-100+)",
	B: "(81-91)",
	C: "(69-80)",
	D: "(55-68)",
	E: "(39-54)",
	F: "(21-38)",
	G: "(0-20)",
	Ungraded: "",
};

const EpcDataBreakdown = ({ data }: EpcDataBreakdownProps) => {
	const percentagesByGrade: { [key: string]: number } = {};

	epcGrades.forEach((grade) => {
		let dataVal;
		if (grade !== "Ungraded") {
			dataVal = Number(data["total_grade_" + grade.toLowerCase()]);
		} else if (data["ungraded"] != null) {
			dataVal = Number(data["ungraded"]);
		} else {
			return;
		}
		percentagesByGrade[grade] = Math.round(100 * (dataVal / Number(data.total_properties)));
	});

	return (
		<Grid divided="vertically">
			{epcGrades.map((grade) => {
				const colName = grade === "Ungraded" ? "ungraded" : "total_grade_" + grade.toLowerCase();

				if (grade === "Ungraded" && !data[colName]) {
					// auto hide when no ungraded properties
					return <Fragment key={grade}></Fragment>;
				}

				const filter: Filter = {
					accessor: "metrics.epc_rating_grade",
					term: grade,
				};
				const queryString = compressDataTableState({ filters: [filter] });
				const link = `/epc-data?${queryString}`;

				return (
					<Grid.Row key={grade} style={{ paddingTop: 0, paddingBottom: 0 }}>
						<Grid.Column width={2}>
							<Link to={link}>
								<EpcRatingTile grade={grade} compact />
							</Link>
						</Grid.Column>
						<Grid.Column width={5}>
							<Link to={link}>{`${grade} ${rangesByGrade[grade]}`}</Link>
						</Grid.Column>
						<Grid.Column width={5}>
							<Link to={link}>
								<h4>{data[colName]}</h4>
							</Link>
						</Grid.Column>
						<Grid.Column width={4}>
							<Link to={link}>{percentagesByGrade[grade]}%</Link>
						</Grid.Column>
					</Grid.Row>
				);
			})}
		</Grid>
	);
};

export default EpcDataBreakdown;
